const initialState = {
  classroomIds: [],
  loading: false,
};

const getClassroomsByFetchedIds = (action) =>
  action.result ? action.result : initialState.classroomIds;

export default function classroomListReducer(state = initialState, action) {
  switch (action.type) {
    case "CLASSROOMS_SEARCH_FETCH_REQUEST":
    case "CLASSROOMS_FETCH_REQUESTED":
      return { ...state, loading: true };
    case "CLASSROOMS_FETCHED":
      return {
        ...state,
        classroomIds: getClassroomsByFetchedIds(action),
        loading: false,
      };
    default:
      return state;
  }
}
